import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';
import { provideHighcharts } from 'highcharts-angular';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';
import {
  EyeInvisibleOutline,
  EyeOutline,
  UserOutline,
  LockOutline,
  FileOutline,
  MenuFoldOutline,
  TeamOutline,
  MailOutline,
  SettingOutline,
  EditOutline,
  InboxOutline,
  UploadOutline,
  GiftOutline,
  SearchOutline,
  FilePdfOutline,
  DownloadOutline,
  CloseOutline,
  DeleteOutline,
  PlusOutline,
  MinusOutline,
  MenuUnfoldOutline,
  MoreOutline,
  ProfileOutline,
  LogoutOutline,
  ExportOutline,
  FileExcelOutline,
  FileTextOutline,
  ArrowRightOutline,
  CopyOutline,
  ArrowDownOutline,
  ArrowUpOutline,
  MobileOutline,
  InfoOutline,
  CheckCircleFill,
  ExclamationCircleFill,
} from '@ant-design/icons-angular/icons';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { AgGridModule } from 'ag-grid-angular';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { coreApiReducer } from './ngrx/core-api/coreapi.reducer';
import { CoreApiEffects } from './ngrx/core-api/coreapi.effects';
import { AuthInterceptor } from './_interceptor/auth.interceptor';
import { timeseriesReducer } from './ngrx/time-series/time-series.reducer';
import { TimeseriesApiEffects } from './ngrx/time-series/time-series.effects';
import { provideMarkdown } from 'ngx-markdown';
import { osmaScreenerReducer } from './ngrx/osma-screener/osma-screener.reducer';
import { instrumentReducer } from './ngrx/instrument/instrument.reducer';
import { InstrumentEffects } from './ngrx/instrument/instrument.effects';
import { portfolioReducer } from './ngrx/portfolio/portfolio.reducer';
import { PortfolioEffects } from './ngrx/portfolio/portfolio.effects';
import { entityReducer } from './ngrx/entity/entity.reducer';
import { EntityEffects } from './ngrx/entity/entity.effects';
import { advisorReducer } from './ngrx/advisor/advisor.reducer';
import { AdvisorEffects } from './ngrx/advisor/advisor.effects';
import { clientReducer } from './ngrx/client/client.reducer';
import { ClientEffects } from './ngrx/client/client.effects';
import { accountReducer } from './ngrx/account/account.reducer';
import { AccountEffects } from './ngrx/account/account.effects';
import { custodianReducer } from './ngrx/custodian/custodian.reducer';
import { CustodianEffects } from './ngrx/custodian/custodian.effects';
import { strategyReducer } from './ngrx/strategy/strategy.reducer';
import { StrategyEffects } from './ngrx/strategy/strategy.effects';
export const appConfig: ApplicationConfig = {
  providers: [
    provideHighcharts(),
    provideMarkdown(),
    { provide: NZ_I18N, useValue: en_US },
    importProvidersFrom(
      NzButtonModule,
      NzIconModule,
      ScrollingModule,
      AgGridModule,
      NzModalModule,
      StoreModule.forRoot({
        coreApi: coreApiReducer,
        timeSeries: timeseriesReducer,
        osmaScreener: osmaScreenerReducer,
        instrument: instrumentReducer,
        portfolio: portfolioReducer,
        entity: entityReducer,
        advisor: advisorReducer,
        client: clientReducer,
        account: accountReducer,
        custodian: custodianReducer,
        strategy: strategyReducer,
      }), // register reducer
      EffectsModule.forRoot([
        CoreApiEffects,
        TimeseriesApiEffects,
        InstrumentEffects,
        PortfolioEffects,
        EntityEffects,
        AdvisorEffects,
        ClientEffects,
        AccountEffects,
        CustodianEffects,
        StrategyEffects,
      ])
    ),
    {
      provide: NZ_ICONS,
      useValue: [
        UserOutline,
        EyeOutline,
        EyeInvisibleOutline,
        LockOutline,
        FileOutline,
        MenuFoldOutline,
        TeamOutline,
        MailOutline,
        SettingOutline,
        EditOutline,
        InboxOutline,
        UploadOutline,
        GiftOutline,
        SearchOutline,
        FilePdfOutline,
        DownloadOutline,
        CloseOutline,
        DeleteOutline,
        PlusOutline,
        MinusOutline,
        MenuUnfoldOutline,
        MoreOutline,
        ProfileOutline,
        LogoutOutline,
        ExportOutline,
        FileExcelOutline,
        FileTextOutline,
        ArrowRightOutline,
        ArrowDownOutline,
        ArrowUpOutline,
        CopyOutline,
        MobileOutline,
        InfoOutline,
        CheckCircleFill,
        ExclamationCircleFill,
      ],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    CurrencyPipe,
    PercentPipe,
    provideNzDateFnsAdapter()
  ],
};
